/**
 * This module is handle certain event tracking to the datalayer (GTM / GA)
 */

document.addEventListener('DOMContentLoaded', (event) => {
    document.querySelectorAll('.datalayer__click').forEach((el) => {
        window.debug = el;
        // Attach onClick event
        el.addEventListener('click', () => {
            const data = el.dataset.tracking;
            if (data) {
                // Try and parse json
                eventData = JSON.parse(data);
                // Send to the datalayer
                window.dataLayer = window.dataLayer || [];
                dataLayer.push(eventData);
                // console.log(eventData);
            }
        });
    });
});
